import React from 'react';
import { Tooltip } from 'react-tooltip';

import { Button } from './buttons/Button';
import { Close } from '../assets/Close';
import { InlineSpinner } from '../assets/Spinner';

export interface PostCancelModalProps {
  onConfirm: () => void;
  onSecondaryAction: () => void;
  onCancel: () => void;
  isProcessLoading?: boolean;
  isDisabled?: boolean;
  isSecondaryActionDisabled?: boolean;
}

export const PostCancelModal = ({
  onConfirm,
  onCancel,
  onSecondaryAction,
  isProcessLoading = false,
  isDisabled = false,
  isSecondaryActionDisabled = false,
}: PostCancelModalProps) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-md p-6 w-[510px] relative border">
        <Close
          className="absolute top-4 right-6 w-8 h-8 cursor-pointer"
          onClick={isProcessLoading ? undefined : onCancel}
        />
        <h3 className="text-2xl font-semibold mb-6 text-center mt-3">
          This order has been cancelled.
          <br /> What would you like to do next?
        </h3>
        <div className="flex flex-col justify-center gap-2">
          <div className="flex justify-center" data-tooltip-id="modification-ineligible-tooltip">
            <Button
              variant={isProcessLoading ? 'secondary' : 'primary'}
              label={isProcessLoading ? <InlineSpinner /> : 'Send to a Different Address'}
              isDisabled={isDisabled || isProcessLoading}
              onClick={onConfirm}
            />
            {isDisabled && (
              <Tooltip id="modification-ineligible-tooltip" place="top" positionStrategy="fixed">
                This order is not eligible to be shipped to a different address.
              </Tooltip>
            )}
          </div>
          <div className="flex justify-center">
            <span
              className={`font-bold underline self-center ${
                isSecondaryActionDisabled ? 'text-gray' : 'hover:cursor-pointer'
              }`}
              onClick={isSecondaryActionDisabled ? undefined : onSecondaryAction}
              data-tooltip-id="refund-ineligible-tooltip"
            >
              Proceed to Process a Refund
            </span>
            {isSecondaryActionDisabled && (
              <Tooltip id="refund-ineligible-tooltip" place="top" positionStrategy="fixed">
                This order is not eligible for a refund.
              </Tooltip>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
